import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
/**
 * Decline-battle confirmation, only reachable during a participant's own
 * first move (see CardSlider's currentTurn === 1 gate). Unlike surrender/
 * draw this isn't a recorded outcome — the battle and its discussion are
 * both deleted server-side, as if the challenge had never happened.
 */
export default class DeclineBattleConfirmModal extends Modal {
  loading = false;
  className() {
    return 'ArenaDeclineModal Modal--small';
  }
  title() {
    return m('[', null, m("i", {
      className: "fas fa-door-closed"
    }), " ", app.translator.trans('forumaker-arena.forum.decline_battle.title'));
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "ArenaDeclineModal-text"
    }, app.translator.trans('forumaker-arena.forum.decline_battle.confirm_text')), m("div", {
      className: "ArenaDeclineModal-actions"
    }, m(Button, {
      className: "Button Button--primary Button--block",
      icon: "fas fa-door-closed",
      loading: this.loading,
      onclick: () => this.decline()
    }, app.translator.trans('forumaker-arena.forum.decline_battle.confirm_btn')), m(Button, {
      className: "Button Button--block",
      disabled: this.loading,
      onclick: () => this.hide()
    }, app.translator.trans('forumaker-arena.forum.decline_battle.cancel_btn'))));
  }
  async decline() {
    this.loading = true;
    m.redraw();
    try {
      await app.request({
        method: 'POST',
        url: `${app.forum.attribute('apiUrl')}/arena/battles/${this.attrs.battle.id()}/decline`,
        errorHandler: () => {} // see ArenaProfilePage.tsx saveDeck()
      });
      this.hide();
      this.attrs.onDeclined?.();
    } catch {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('forumaker-arena.forum.decline_battle.error'));
      this.loading = false;
      m.redraw();
    }
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/DeclineBattleConfirmModal', DeclineBattleConfirmModal);